export default "__VITE_ASSET__DtOzheie__"